import React, { useState } from "react";

const CONTACT_EMAIL = "luxerakalima@gmail.com";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const onSubmit = (e) => {
    e.preventDefault();
    const body = `${form.message}%0D%0A%0D%0AFrom: ${form.name} (${form.email})`;
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(form.subject || "Website contact")}&body=${body}`;
    setSent(true);
    setForm({ name: "", email: "", subject: "", message: "" });
  };
  return (
    <main className="py-20" data-testid="contact-page">
      <div className="max-w-2xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.4em] uppercase text-[var(--gold-deep)] mb-4">— Get in Touch</div>
          <h1 className="font-display text-5xl lg:text-6xl">Contact Us</h1>
          <p className="text-[var(--grey)] mt-4">We respond within 24 hours, 7 days a week.</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5" data-testid="contact-form">
          <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 bg-white outline-none focus:border-[var(--noir)]" data-testid="contact-name" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 bg-white outline-none focus:border-[var(--noir)]" data-testid="contact-email" />
          <input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 bg-white outline-none focus:border-[var(--noir)]" />
          <textarea required rows={5} placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-[var(--champagne-deep)] px-4 py-3 bg-white outline-none focus:border-[var(--noir)]" data-testid="contact-message" />
          <button className="btn-lux w-full bg-[var(--noir)] text-[var(--ivory)] py-4 text-[11px] tracking-[0.25em] uppercase hover:text-[var(--gold)]" data-testid="contact-submit">Send Message</button>
          {sent && <p className="text-[var(--gold-deep)] text-sm text-center" data-testid="contact-success">✦ Thank you! We'll get back to you within 24h.</p>}
        </form>
        <div className="mt-12 text-center text-sm text-[var(--grey)]">
          <p>{CONTACT_EMAIL}</p>
          <p className="mt-1">Customer Care 7/7</p>
        </div>
      </div>
    </main>
  );
};

export default ContactPage;
